import { SectionHeading } from './SectionHeading'

const links = [
  { label: 'GitHub', href: 'https://github.com/Nishino0719' },
  { label: 'Zenn', href: 'https://zenn.dev/nishino' },
  { label: 'メール', href: 'mailto:info@nishino0719.com' }
]

export const Links = () => {
  return (
    <section id="contact" className="py-12 border-t border-ink-100">
      <SectionHeading number="08" title="連絡" />
      <ul className="space-y-3 text-base">
        {links.map(({ label, href }) => (
          <li key={label}>
            <a
              href={href}
              target={href.startsWith('mailto:') ? undefined : '_blank'}
              rel={
                href.startsWith('mailto:') ? undefined : 'noopener noreferrer'
              }
              className="inline-flex items-baseline gap-4 text-ink-800"
            >
              <span className="font-mono text-xs text-ink-600 tracking-wider uppercase w-16">
                {label}
              </span>
              <span className="underline decoration-ink-400/30">
                {href.replace(/^mailto:/, '').replace(/^https?:\/\//, '')}
              </span>
              {!href.startsWith('mailto:') && (
                <span className="sr-only">
                  （外部サイト、新しいタブで開く）
                </span>
              )}
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
